export default __webpack_public_path__ + "static/image-social-media-dashboard-0751d76b54bdc9a169d1a87c394c8b0a.png";